
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-owners/buying",
      function () {
        return require("private-next-pages/home-owners/buying.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-owners/buying"])
      });
    }
  